// =====================================================
// 视图切换组件
// 支持面包屑导航和树形视图切换
// =====================================================

import React from 'react';
import { List, FolderTree } from 'lucide-react';
import type { ViewMode } from '../../types/hierarchy';

interface ViewToggleProps {
  mode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewToggle({ mode, onChange }: ViewToggleProps) {
  return (
    <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-lg">
      <button
        onClick={() => onChange('breadcrumb')}
        className={`
          flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium
          transition-all duration-200
          ${mode === 'breadcrumb' 
            ? 'bg-white text-gray-900 shadow-sm' 
            : 'text-gray-600 hover:text-gray-900'
          }
        `}
        title="面包屑导航（默认）"
      >
        <List className={`w-4 h-4 ${mode === 'breadcrumb' ? 'text-blue-600' : ''}`} />
        <span className="hidden sm:inline">列表</span>
      </button>
      <button
        onClick={() => onChange('tree')}
        className={`
          flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium
          transition-all duration-200
          ${mode === 'tree' 
            ? 'bg-white text-gray-900 shadow-sm' 
            : 'text-gray-600 hover:text-gray-900'
          }
        `}
        title="树形视图"
      >
        <FolderTree className={`w-4 h-4 ${mode === 'tree' ? 'text-blue-600' : ''}`} />
        <span className="hidden sm:inline">树形</span>
      </button>
    </div>
  );
}

// =====================================================
// 带标签的视图切换
// =====================================================

interface ViewToggleWithLabelProps extends ViewToggleProps {
  label?: string;
}

export function ViewToggleWithLabel({ 
  mode, 
  onChange, 
  label = '视图' 
}: ViewToggleWithLabelProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-500">{label}:</span>
      <ViewToggle mode={mode} onChange={onChange} />
    </div>
  );
}

export default ViewToggle;
